<div id="map-mobile" class="map-mobile"></div>
<button id="resetViewButton" (click)="resetView()" style="display:none">
    {{ 'MAP.RESET' | translate }} <fa-icon [icon]="faCross"></fa-icon>
</button>
<ng-template #iconTemplate let-item>
    <div class="icon-overlay" [ngStyle]="{'border-color': item.capteur.borderColor}">
    <i *ngIf="item.capteur.type != 'hydrometrie' && item.capteur.type != 'pluviometres'" [class]="item.capteur.icon" 
    [ngClass]="item.capteur.dataType === 'Source' ? 'icon-symbol-square' : 'icon-symbol-circle'" 
     [style]="{'color': item.capteur.textColor, 'font-size': item.capteur.fontSize, 'background-color': item.capteur.backgroundColor, 'border': item.capteur.border, 'cursor': item.capteur.cursor , 'padding': item.capteur.padding }"
        ></i>
    <fa-icon *ngIf="item.capteur.type === 'hydrometrie' || item.capteur.type === 'pluviometres'" [icon]="item.capteur.icon" [styles]="{'color': item.capteur.textColor, 'font-size': item.capteur.fontSize, 'background-color': item.capteur.backgroundColor, 'border': item.capteur.border, 'cursor': item.capteur.cursor,  'padding': item.capteur.padding, 'transform': item.capteur.transform }"></fa-icon>
    </div>
    
</ng-template>

<div #iconsContainer></div>
<div *ngIf="isLoadingSensors || isLoadingBsn" class="loading-content-mobile">
    <fa-icon [icon]="faSpinner"></fa-icon>
    <div>{{ 'MAP.LOADING_SENSOR' | translate }}</div>
</div>
<app-headband-mobile [ipsData]="ipsDataOfSelectedSensor" [hasModel]="hasModalForHeadband"></app-headband-mobile>

